import { render, staticRenderFns } from "./LessonTestQuestionAnswers.vue?vue&type=template&id=364537fb&scoped=true"
import script from "./LessonTestQuestionAnswers.vue?vue&type=script&lang=js"
export * from "./LessonTestQuestionAnswers.vue?vue&type=script&lang=js"
import style0 from "./LessonTestQuestionAnswers.vue?vue&type=style&index=0&id=364537fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../edeone/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364537fb",
  null
  
)

export default component.exports